<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>{{sprint.name}}</v-toolbar-title>
    </v-toolbar>
    <v-list>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Start</v-list-tile-title>
          <v-list-tile-sub-title>{{ sprint.start | formatDate }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>End</v-list-tile-title>
          <v-list-tile-sub-title>{{ sprint.end | formatDate }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content v-if="sprint.active">
          <v-list-tile-title>Activated</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :to="{name : 'Show Sprint', params: {id : sprint.id}}">
        Show Details
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'SprintCard',
  props: {
    sprint: Object,
  },
};
</script>
